export const antTheme = {
  components: {
    Table: {
      headerBg: 'rgb(255,255,255)',
      headerSplitColor: 'rgba(240,240,240,0)',
    },
  },
};
